"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("source-map-support/register");

var DomainErrorTypes;

(function (DomainErrorTypes) {
  DomainErrorTypes["VALIDATION"] = "Validation";
  DomainErrorTypes["DATA_MISSING"] = "DataMissing";
  DomainErrorTypes["CONNECTION"] = "Connection";
  DomainErrorTypes["EXECUTION"] = "Execution";
})(DomainErrorTypes || (DomainErrorTypes = {}));

exports["default"] = DomainErrorTypes;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9FcnJvci9Eb21haW5FcnJvclR5cGVzLnRzIl0sIm5hbWVzIjpbIkRvbWFpbkVycm9yVHlwZXMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7O0lBQUtBLGdCOztXQUFBQSxnQjtBQUFBQSxFQUFBQSxnQjtBQUFBQSxFQUFBQSxnQjtBQUFBQSxFQUFBQSxnQjtBQUFBQSxFQUFBQSxnQjtHQUFBQSxnQixLQUFBQSxnQjs7cUJBT1VBLGdCIiwic291cmNlc0NvbnRlbnQiOlsiZW51bSBEb21haW5FcnJvclR5cGVzIHtcbiAgICBWQUxJREFUSU9OID0gJ1ZhbGlkYXRpb24nLFxuICAgIERBVEFfTUlTU0lORyA9ICdEYXRhTWlzc2luZycsXG4gICAgQ09OTkVDVElPTiA9ICdDb25uZWN0aW9uJyxcbiAgICBFWEVDVVRJT04gPSAnRXhlY3V0aW9uJyxcbn1cblxuZXhwb3J0IGRlZmF1bHQgRG9tYWluRXJyb3JUeXBlcztcbiJdfQ==